function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stringify } from 'query-string';
import { HttpClient } from 'api/http-client';
const baseUrl = '/field-sections';
export class FieldSectionClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAllFieldSections", (sectionType, sectionSubType)=>this.get(`${baseUrl}?${stringify({
                fieldSectionType: sectionType,
                fieldSectionSubType: sectionSubType
            }, {
                skipNull: true
            })}`)), _define_property(this, "createFieldSection", (fieldSectionPayload)=>this.post(baseUrl, fieldSectionPayload)), _define_property(this, "updateFieldSection", (fieldSection)=>this.put(`${baseUrl}/${fieldSection.fieldSectionId}`, fieldSection)), _define_property(this, "deleteFieldSection", (fieldSectionId)=>this.delete(`${baseUrl}/${fieldSectionId}`)), _define_property(this, "updateFieldSectionOrder", ({ fieldId, fieldSectionId, fieldOrderIndex })=>this.put(`${baseUrl}/${fieldSectionId}/update-order`, {
                fieldId,
                fieldOrderIndex
            })), _define_property(this, "shiftSections", async (sectionType, sectionOrderDetailsList)=>this.put(`${baseUrl}/update-order?${stringify({
                fieldSectionType: sectionType
            })}`, {
                sectionOrderDetailsList
            }));
    }
}
export const FieldSectionApi = new FieldSectionClient();
